var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "video-page-background-extra-options" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("div", { staticClass: "row-label" }, [_vm._v("背景图片 URL")]),
        _vm._v(" "),
        _c(_setup.TextBox, {
          attrs: {
            text: _setup.urlInput,
            "change-on-blur": true,
            placeholder: "https://...",
          },
          on: { change: _setup.updateUrl },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "actions" },
      [
        _c(_setup.VButton, { on: { click: _setup.selectLocalImage } }, [
          _vm._v("选择本地图片"),
        ]),
        _vm._v(" "),
        _c(
          _setup.VButton,
          {
            attrs: { disabled: !_setup.hasImage },
            on: { click: _setup.clearImage },
          },
          [_vm._v("清除")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _setup.isLocalImage
      ? _c(
          "div",
          {
            staticClass: "status",
            attrs: { title: _setup.backgroundImage.name },
          },
          [
            _vm._v(
              "\n    已使用本地图片：" +
                _vm._s(_setup.backgroundImage.name) +
                "\n  "
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _setup.hasImage
      ? _c("div", { staticClass: "preview" }, [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_setup.previewFailed,
                expression: "!previewFailed",
              },
            ],
            attrs: { src: _setup.backgroundImage.url, alt: "背景图片预览" },
            on: {
              load: function ($event) {
                _setup.previewFailed = false
              },
              error: function ($event) {
                _setup.previewFailed = true
              },
            },
          }),
          _vm._v(" "),
          _setup.previewFailed
            ? _c("div", { staticClass: "preview-error" }, [
                _vm._v("图片加载失败"),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "description" }, [
      _vm._v(
        "\n    本地图片以 Base64 形式保存在组件设置中，大小不能超过 " +
          _vm._s(_setup.localUploadLimit) +
          " KiB。\n  "
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }